let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3k7Xl")).then(() => parcelRequire('7TyPQ'));